import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";
import { SNAPSHOT } from "../lib/snapshot";
import { validateCheckoutOptions } from "../lib/checkoutMode";

export function useCheckoutOptions(active = true, refreshKey = "") {
  const [options, setOptions] = useState(null);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  const reload = useCallback(() => setRetry((n) => n + 1), []);
  useEffect(() => {
    if (!active || SNAPSHOT) return;
    let alive = true;
    let sequence = 0;
    const refresh = () => {
      const current = ++sequence;
      setOptions(null); setError("");
      api.get("/public/payment-options", { params: { _fresh: Date.now() } })
        .then(({ data }) => { if (alive && current === sequence) setOptions(validateCheckoutOptions(data)); })
        .catch((e) => { if (alive && current === sequence) { setOptions(null); setError(errMsg(e)); } });
    };
    refresh();
    window.addEventListener("focus", refresh);
    return () => { alive = false; window.removeEventListener("focus", refresh); };
  }, [active, refreshKey, retry]);
  return { options, error, reload };
}
